/**
 * Main application entry point.
 */

'use strict';

var app = require('mag-app'),
    config = require('./config'),
    api = require('./modules/api'),
    PROXY = (top.system && top.system.queryParameters && top.system.queryParameters.proxy) ?
        top.system.queryParameters.proxy : false;

window.AURA = false;

// apply patch to use 'on'
require('./modules/emitter.patch');

function done ( error ) {
    // show main page
    app.route(app.pages.main);
    app.ready();
    if ( !error ) {
        require('./modules/ui').updateUID();
    }
}

// everything is ready
app.once('load', function () {
    require('spa-gettext').load({name: core.environment.language}, function () {
        var proxyConfig;

        /**
         * Redefine app exit function
         */
        app.exit = function () {
            if ( app.events['exit'] ) {
                app.emit('exit');
            }
            if ( PROXY && window.top.gSTB ) {
                window.top.gSTB.ResetWebProxy(); //eslint-disable-line
            }

            core.call('exit');
        };

        // we need to waite till images are loaded. cause if we will turn on proxy some hidden images will be lost
        require('./modules/ui').preloadImages(function () {
            // apply proxy settings for stand alone mode if needed
            if ( PROXY && window.top.gSTB ) {
                proxyConfig = api.parseUriString(PROXY);
                window.top.gSTB.SetWebProxy(proxyConfig.host, parseInt(proxyConfig.port), '', '', ''); //eslint-disable-line
                config.forceLongPolling = true;
            }
            // load pages
            app.pages = {
                main: require('./pages/main')
            };

            api.getUID(function ( error ) {
                if ( error ) {
                    done(true);
                } else {
                    // hmmmmmm
                    done();
                }
            });
        });

    });
});
